export enum DATA_QA {
  ROOT = 'dnc-dialpad-property-select',
}
